import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

interface NavItem {
  to: string;
  label: string;
}

const NAV: NavItem[] = [
  { to: '/trips', label: 'Book a Trip' },
  { to: '/track', label: 'Track Parcel' },
];

const PublicHeader: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-30 border-b border-dusk-100 bg-white/95 font-road backdrop-blur-md supports-[backdrop-filter]:bg-white/85">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
        <Link
          to="/"
          className="inline-flex items-center rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-livery-600 focus-visible:ring-offset-4"
        >
          {/* Slanted wordmark, as painted on the shuttles */}
          <span className="-skew-x-6 bg-livery-600 px-2.5 py-1 font-signage text-[1.45rem] font-extrabold italic uppercase leading-none tracking-wide text-white">
            Cruiser
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [
                  'relative rounded-md px-3.5 py-2 text-[15px] font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-livery-600',
                  isActive
                    ? 'text-dusk-900'
                    : 'text-dusk-500 hover:text-dusk-900',
                ].join(' ')
              }
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  {isActive && (
                    <span
                      aria-hidden
                      className="absolute inset-x-3.5 -bottom-[13px] h-[3px] bg-livery-600"
                    />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/login"
            className="hidden h-10 items-center rounded-md border border-dusk-200 px-4 text-sm font-semibold text-dusk-800 transition-colors hover:border-dusk-400 hover:bg-dusk-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-livery-600 md:inline-flex"
          >
            Sign in
          </Link>
          <button
            type="button"
            aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen((v) => !v)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-md text-dusk-800 hover:bg-dusk-50 md:hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-livery-600"
          >
            {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="border-t border-dusk-100 bg-white md:hidden">
          <nav className="flex flex-col px-4 py-3">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  [
                    'rounded-md px-3 py-3 text-base font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-livery-600',
                    isActive
                      ? 'bg-livery-50 text-livery-700'
                      : 'text-dusk-800 hover:bg-dusk-50',
                  ].join(' ')
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/login"
              onClick={() => setMobileOpen(false)}
              className="mt-2 rounded-md border border-dusk-200 px-3 py-3 text-center text-base font-semibold text-dusk-800 hover:bg-dusk-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-livery-600"
            >
              Sign in
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default PublicHeader;
